import createIcon from '../../createIcon';

/**
 * @component @name Html
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDlINVYxNUgzLjVWMTIuNUgxLjVWMTVIMFY5SDEuNVYxMUgzLjVWOVpNMTcuNSA5SDEzQzEyLjQ1IDkgMTIgOS40NSAxMiAxMFYxNUgxMy41VjEwLjVIMTQuNVYxNEgxNlYxMC40OUgxN1YxNUgxOC41VjEwQzE4LjUgOS40NSAxOC4wNSA5IDE3LjUgOVpNMTEgOUg2VjEwLjVINy43NVYxNUg5LjI1VjEwLjVIMTFWOVpNMjQgMTVWMTMuNUgyMS41VjlIMjBWMTVIMjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Html = createIcon('Html', [
  [
    'path',
    {
      d: 'M3.5 9H5V15H3.5V12.5H1.5V15H0V9H1.5V11H3.5V9ZM17.5 9H13C12.45 9 12 9.45 12 10V15H13.5V10.5H14.5V14H16V10.49H17V15H18.5V10C18.5 9.45 18.05 9 17.5 9ZM11 9H6V10.5H7.75V15H9.25V10.5H11V9ZM24 15V13.5H21.5V9H20V15H24Z',
      key: '1j8w5q',
    },
  ],
]);

export default Html;
